import moment from "moment";
import { getObservableParams, getQualifiedParamName } from "./DashboardUtils";
import { mockEntries, mockServiceInfo } from "./MockData"

export default function ServiceInfoDataSource(serviceInfo) {

    const { entries: { [0]: data } = [] } = mockServiceInfo || { entries: [] };
    const { service_name, raw_data = [], ...args } = data || { raw_data: [] };

    function asGraphView() {

        const getDate = (unix) => moment(unix).format("YYYY-MM-DD");

        const observableParams = getObservableParams(service_name);

        return raw_data.reduce((acc, { date_key, ...args }) => (
            acc.concat(observableParams.map((param) => {
                const key = getDate(date_key * 1000);
                const value = args[param] || 0;
                return { key, value, type: param };
            }))
        ), []);
    }

    function asStatsView() {

        const observableParams = getObservableParams(service_name);

        return observableParams.map((param) => {
            const value = args[param] || 0; // \u2014
            const title = getQualifiedParamName(param);
            return { key: param, value, title };
        });
    }

    function isEmpty() {
        return service_name === undefined || raw_data.length === 0;
    }

    return { asGraphView, asStatsView, isEmpty };
}